const Bin = ({style = {}}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="20"
    viewBox="0 0 23.2 26.397"
    fontSize="inherit"
    style={{...style}}
  >
    <g id="bin_1_" data-name="bin (1)" transform="translate(-31)">
      <g
        id="Group_1293"
        data-name="Group 1293"
        transform="translate(32.609 7.733)"
      >
        <g id="Group_1292" data-name="Group 1292">
          <path
            id="Path_639"
            data-name="Path 639"
            d="M62.205,150l1.37,16.536a2.332,2.332,0,0,0,2.311,2.127H78.507a2.332,2.332,0,0,0,2.311-2.127L82.188,150Zm6.124,15.57a.773.773,0,0,1-.771-.725l-.773-12.477a.773.773,0,0,1,.723-.82.761.761,0,0,1,.82.723l.773,12.477A.774.774,0,0,1,68.329,165.57Zm4.641-.773a.773.773,0,1,1-1.547,0V152.32a.773.773,0,1,1,1.547,0Zm4.638-12.428-.773,12.477a.773.773,0,1,1-1.544-.1l.773-12.477a.786.786,0,0,1,.82-.723A.773.773,0,0,1,77.608,152.368Z"
            transform="translate(-62.205 -150)"
            fill="inherit"
          />
        </g>
      </g>
      <g id="Group_1295" data-name="Group 1295" transform="translate(31)">
        <g id="Group_1294" data-name="Group 1294">
          <path
            id="Path_640"
            data-name="Path 640"
            d="M52.653,3.093h-4.64V2.32A2.323,2.323,0,0,0,45.693,0H39.507a2.323,2.323,0,0,0-2.32,2.32v.773h-4.64a1.547,1.547,0,0,0,0,3.093H52.653a1.547,1.547,0,1,0,0-3.093Zm-6.187,0H38.733V2.32a.774.774,0,0,1,.773-.773h6.187a.774.774,0,0,1,.773.773Z"
            transform="translate(-31)"
            fill="inherit"
          />
        </g>
      </g>
    </g>
  </svg>
);

export default Bin;
